import React from "react";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";

// Dashboard
import { useGetPayableSummaryQuery } from "../../../services/Reports";
import {
  getPayableSummaryRequest,
  getPayableSummaryFailure,
  getPayableSummarySuccess,
} from "../../../store/slices/reportsSlice";

const Content = () => {
  const dispatch = useAppDispatch();
  const accessToken = useAppSelector((state) => state.common.accessToken);
  const userID = useAppSelector((state) => state.common.userID);
  const profileData = useAppSelector((state) => state.settings.profileData);

  // State
  const state = useAppSelector((state) => state.reports);

  // **************
  // **************
  // Get Dashboard Data
  // **************
  // **************
  const {
    data: allPayableSummary,
    isLoading: payableSummaryLoading,
    isError: payableSummaryError,
  } = useGetPayableSummaryQuery({
    accessToken: accessToken || "",
    userID: userID || "",
    permission: true,
    pageNo: state.payableSummaryPageNo,
    pageSize: state.payableSummaryPageSize,
    fromDate: new Date(state.payableSummaryFromDate).toLocaleDateString(),
    toDate: new Date(state.payableSummaryToDate).toLocaleDateString(),
  });
  React.useEffect(() => {
    if (!accessToken && !userID) {
      return;
    }
    if (!profileData) {
      return;
    }
    if (payableSummaryLoading) {
      dispatch(getPayableSummaryRequest());
    }
    if (payableSummaryError) {
      dispatch(getPayableSummaryFailure(payableSummaryError));
    }
    if (allPayableSummary) {
      dispatch(
        getPayableSummarySuccess({
          data: allPayableSummary.data.payableSummary[0].data || [],
          totalPages:
            allPayableSummary.data.payableSummary[0].metadata[0]?.total || 0,
        }),
      );
    }
  }, [
    accessToken,
    userID,
    allPayableSummary,
    profileData,
    state.payableSummaryFromDate,
    state.payableSummaryToDate,
    state.payableSummaryPageNo,
    state.payableSummaryPageSize,
  ]);
  return <></>;
};
export default Content;
